export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return

  to.query.id = from.query.id
  to.query.key = from.query.key
  to.query.type = from.query.type

  const {
    path,
    query: { id, key, type },
  } = to

  const AVAILABLE_PATHS = {
    isThankYouPage: path.startsWith('/thank_you'),
    isOrderPages: path.startsWith('/orders'),
    isMissingQueryPage: path.startsWith('/missing-url-query-params'),
    isNotFoundPage: path.startsWith('/404'),
  }

  const isMissingSomeParams = [id, key, type].some((item) => !item)
  const isPathAvailable = Object.values(AVAILABLE_PATHS).some((path) => path)

  if (isMissingSomeParams && !isPathAvailable)
    return navigateTo({ path: '/missing-url-query-params', query: from.query })
})
